module.exports = __webpack_public_path__ + "15_hair_silver.8b363aa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/15_hair_silver.png
// module id = Fo0S
// module chunks = 0